<template>
	<!--登录页面-->
	<div>
		<img src="../assets/logo.png" class="logoLogin"/>
		<div class="loginTab clearfix">
			<p class="pswLogin fl" :class="{loginTabon:isloginTabon}" v-on:click="loginTab(0)" >普通登录<span></span></p>
			<p class="codeLogin fr" :class="{loginTabon:!isloginTabon}" v-on:click="loginTab(1)">手机号快捷登录<span></span></p>
		</div>
		<div class="loginBox">
			<div class="loginCon typePsw" v-if="loginShow">
				<p><input type="text" class="userName boxSizing" placeholder="用户名" v-model="username" maxlength="11"/></p>
				<p class="pswBox">
					<input :type="pswType" class="userPsw boxSizing" placeholder="密码" v-model="passwordOrSms" maxlength="12"/>
					<img :src="seen ? require('../assets/eyeclose.png') : require('../assets/eyeopen.png')" class="eyeclose" @click="changeEye"/>
				</p>
			</div>
			<div class="loginCon typeCode" v-if="!loginShow">
				<p><input type="text" class="userName boxSizing" v-model="username" placeholder="手机号" maxlength="11"/></p>
				<p class="pswBox clearfix">
					<input type="text" class="userCode boxSizing fl" placeholder="验证码" v-model="OrSms"  maxlength="8"/>
					<button v-show="timeShow" class="fr getCode" @click="getCode">获取验证码</button>
					<button v-show="!timeShow" class="fr getCode">{{timeCount}}秒后重试</button>
				</p>
			</div>
			<div class="submit" @click="UserLogin">登录</div>
			<div class="forPsw">
				<router-link to="/register">手机号快捷注册</router-link>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import qs from "qs";
// 登录正则
var regphone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
var regPsw = /^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~]{6,12}$/;
//var username = localStorage.getItem("userName") || "";
//var passwordOrSms = localStorage.getItem("passWord") || "";
export default {
  name: "login",
  data() {
    return {
      IsValidate:true,  //是否验证通过
      loginShow: true,
      isloginTabon: true,
      type: 1,
      username: localStorage.getItem("userName"),
      passwordOrSms: localStorage.getItem("passWord")||'',
      OrSms: "",
      seen: true,
      pswType: "password",
      timeShow: true,
      timeCount: "",
      timer: null
    };
  },
  methods: {
      //  登录方式的切换  普通登录  快捷登录
      loginTab: function (num) {
          if (num == 0) {
              this.loginShow = true;
              this.isloginTabon = true;
          } else {
              this.loginShow = false;
              this.isloginTabon = false;
          }
      },
      //密码可见不可见
      changeEye: function () {
          this.seen = !this.seen;
          this.seen == true ? (this.pswType = "password") : (this.pswType = "text");
      },
      ValidateReg(callback){
          // 正则判断
          if (!regphone.test(this.username)) {

              this.IsValidate = false;
              this.Toast({
                  message: "请输入正确的手机号",
                  position: "center",
                  duration: 1000
              });

          } else if (this.loginShow === true && !regPsw.test(this.passwordOrSms)) {

              this.IsValidate = false;
              this.Toast({
                  message: "密码由6-12位数字或字母组成",
                  position: "center",
                  duration: 2000
              });

          }else{
              this.IsValidate = true;
              callback && (typeof(callback) === "function") && callback();
          }
      },
      //优化登陆的逻辑
      UserLogin(){
          //第一步进行验证
          this.ValidateReg(()=>{
              //验证通过进行登陆
              this.Submit();
          });
      },
      Submit() {

        //登录接口
        axios.post("/wap/user/login",qs.stringify({
                    username: this.username,
                    passwordOrSms: this.loginShow === true ? this.passwordOrSms : this.OrSms,
                    type: this.loginShow === true ? 1 : 2
              })
         ).then(data => {

              console.log(data);
              if(data.data.code == 200){
                  let Days = 30;
                  let exp = new Date();
                  exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
                  document.cookie = "userName=" + this.username + ";expires=" + exp;
                  document.cookie = "passWord=" + this.passwordOrSms + ";expires=" + exp;
                  document.cookie = "logined=" + true + ";expires=" + exp;
                  localStorage.setItem("userName", this.username);
                  localStorage.setItem("passWord", this.passwordOrSms);
                  localStorage.setItem("logined", "true");

                  if (this.$route.query.redirect == location.hostname)
                      this.$router.go(-1);
                  else
                      this.$router.push({path: '/'});

              } else {
                  this.Toast({
                    message: data.data.msg,
                    position: "center",
                    duration: 2000
                  })
              }

         }).catch((error)=>{

            console.log(error);
         })
      },
      // 获取验证码
      getCode: function () {
          if (!regphone.test(this.username)) {
              this.Toast({
                  message: "请输入正确的手机号",
                  position: "center",
                  duration: 1000
              });
              return false;
          } else {
              // ajax
              axios
                  .post(
                      "/wap/user/createSmsCode",
                      qs.stringify({
                          phone: this.username
                      })
                  )
                  .then(data => {
                      console.log(data.data);
                      if (data.data.code == '200') {
                          this.Toast({
                              message: "验证码获取成功",
                              position: "center",
                              duration: 2000
                          });
                          // 验证码倒计时
                          let wait = 59;
                          if (!this.timer) {
                              this.timeCount = wait;
                              this.timeShow = false;
                              this.timer = setInterval(() => {
                                  if (this.timeCount > 1 && this.timeCount <= 60) {
                                      this.timeCount--;
                                  } else {
                                      this.timeShow = true;
                                      clearInterval(this.timer);
                                      this.timer = null;
                                  }
                              }, 1000);
                          }
                      } else {
                          this.Toast({
                              message: data.data.msg,
                              position: "center",
                              duration: 2000
                          });
                      }

                  })
                  ["catch"](error => {
                  console.log(error);
              });
          }
      }
  }
}
</script>
<style scoped lang="scss">
.mint-header {
  height: 88px;
  line-height: 88px;
  background-color: #f6f7f8;
  border-bottom: 1PX solid #e1e1e1;
  color: #333;
  font-size: 36px;
  font-weight: bold;
  padding: 0 30px;
  /deep/ h1 {
    font-weight: bold;
  }
}
.mint-button /deep/ i {
  font-size: 36px;
  color: #333;
  font-weight: bold;
}
.logoLogin {
  width: 142px;
  height: 142px;
  margin: 97px auto 79px;
}
.loginTab {
  padding: 0 120px;
  font-size: 30px;
  span {
    display: block;
    width: 30px;
    height: 10px;
    margin: 4px auto 0;
    border-radius: 5px;
    background: #fff;
  }
}
.loginTabon {
  color: #ff7f02;
  span {
    background: #ff7f02;
  }
}
.loginBox .typePsw,
.typeCode {
  width: 90%;
  margin: 0 auto;
  .userName,
  .userPsw,
  .userCode,
  .getCode {
    display: block;
    margin-top: 42px;
    width: 100%;
    height: 80px;
    /*line-height: 80px;*/
    text-indent: 70px;
    font-size: 26px;
    background: url(../assets/userPho.png) no-repeat 30px center;
    background-size: 40px 40px;
    border: 1PX solid #e1e1e1;
    border-radius: 40px;
  }
  .userPsw {
    background: url(../assets/userPsw.png) no-repeat 20px center;
    background-size: 40px 40px;
  }
  .pswBox {
    position: relative;
  }
  .eyeclose {
    position: absolute;
    right: 30px;
    bottom: 20px;
    width: 40px;
    height: 40px;
  }
  .typeCode .userPsw {
    width: 60%;
  }
  .typeCode span {
    width: 30%;
    height: 100%;
    border: 1PX solid #ff7f02;
    border-radius: 40px;
  }
  .userCode {
    width: 60%;
    background: url(../assets/code.png) no-repeat 20px center;
    background-size: 40px 40px;
  }
  .getCode {
    width: 34%;
    background: none;
    text-align: center;
    text-indent: 0;
    font-size: 26px;
    color: #ff7f02;
    border-color: #ff7f02;
  }
}
.submit {
  width: 90%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fff;
  margin: 100px auto 40px;
  font-size: 32px;
  border-radius: 40px;
  background: url(../assets/loginBg.png) no-repeat center center;
}
.forPsw {
  text-align: center;
  color: #666;
  font-size: 26px;
}
</style>
